import React from "react";
import { bulkActionsToolbarStyle } from "./style";
import CloseIcon from '@material-ui/icons/Close';
import { Grid, IconButton, Tooltip } from "@material-ui/core";

const BulkActionsToolbar = ({ selectedRows, actions, allData, onClear }) => {
    const classes = bulkActionsToolbarStyle();
    return (
        <div className={classes.container}>
            <div className={classes.selectedCount}>{selectedRows?.length}</div>
            <div className={classes.selectedText}>Records selected</div>
            <Grid container wrap="nowrap" alignItems="center" className={classes.actions}>
                {actions?.filter(React.isValidElement).map((a, i) => <Grid item key={a.key ?? i}>
                    {React.cloneElement(a, { selectedRows, allData, onClear })}
                </Grid>)}
            </Grid>
            {!!selectedRows?.length && <div className={classes.clearIcon}>
                <Tooltip title='Clear selection'>
                    <IconButton size="small" onClick={onClear}><CloseIcon /></IconButton>
                </Tooltip>
            </div>}
        </div>
    )
}
export default BulkActionsToolbar;